import { render, staticRenderFns } from "./TemplateDropdownV2.vue?vue&type=template&id=677c907d&scoped=true"
import script from "./TemplateDropdownV2.vue?vue&type=script&lang=js"
export * from "./TemplateDropdownV2.vue?vue&type=script&lang=js"
import style0 from "./TemplateDropdownV2.vue?vue&type=style&index=0&id=677c907d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677c907d",
  null
  
)

export default component.exports